import * as React from 'react';
import { useSelector } from 'react-redux';
import { Summaries } from '../../../components/RealtyValuation';
import { getRealtyValuation, getAvgPrices, getAvgPricesSqm, getSoldData } from '../../../selectors/realtyValuation';

export function SummariesContainer() {
  const realtyValuation = useSelector(getRealtyValuation);

  if (!realtyValuation) {
    return null;
  }

  const avgPrices = getAvgPrices(realtyValuation);
  const avgPricesSqm = getAvgPricesSqm(realtyValuation);
  const soldData = getSoldData(realtyValuation);

  return <Summaries prices={avgPrices} pricesSqm={avgPricesSqm} soldData={soldData} />;
}
